(() => {
  const sections = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const moreContrast = window.matchMedia('(prefers-contrast: more)');
  let scheduled = false;

  const clamp = (value) => Math.max(0, Math.min(1, value));

  function update() {
    scheduled = false;
    const animate = !reducedMotion.matches && !moreContrast.matches;

    for (const section of sections) {
      if (!section.isConnected) {
        sections.delete(section);
        continue;
      }

      section.classList.toggle('mm-story--motion', animate);
      if (!animate) continue;

      const box = section.getBoundingClientRect();
      const progress = clamp((window.innerHeight - box.top) / (window.innerHeight + box.height));
      const movement = clamp((progress - 0.12) / 0.34);
      const shift = (window.innerWidth < 700 ? -30 : -60) * movement;

      section.querySelectorAll('.mm-story__title-line').forEach((line, index) => {
        const highlight = clamp((progress - 0.04 - index * 0.13) / 0.13);
        line.style.setProperty('--mm-story-line-highlight', `${Math.round(highlight * 100)}%`);
      });
      section.style.setProperty('--mm-story-product-shift', `${Math.round(shift)}px`);

      const featureGrid = section.querySelector('.mm-story__features');
      if (featureGrid) {
        const gridTop = featureGrid.getBoundingClientRect().top;
        const revealDistance = Math.max(120, Math.min(200, window.innerHeight * 0.25));
        featureGrid.querySelectorAll('.mm-story__feature').forEach((feature, index) => {
          const stagger = window.innerWidth >= 700 ? (index % 2) * 36 : 0;
          const featureTop = gridTop + feature.offsetTop;
          const reveal = clamp((window.innerHeight * 0.92 - featureTop - stagger) / revealDistance);
          feature.style.setProperty('--mm-story-feature-opacity', reveal.toFixed(3));
          feature.style.setProperty('--mm-story-feature-shift', `${Math.round((1 - reveal) * 24)}px`);
        });
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  function initialize(root = document) {
    if (root.matches?.('.mm-story')) sections.add(root);
    root.querySelectorAll('.mm-story').forEach((section) => sections.add(section));
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reducedMotion.addEventListener('change', schedule);
  moreContrast.addEventListener('change', schedule);
})();
